module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAFoTx1HAAAAAXNSR0IArs4c6QAAAO9JREFUKBWlkT0KwkAUhJPgT6wERTyAB7C3FjvP5QmsvEUaIV7BIqewEA9gEYjfrHlrwiYiODDsezNvdpPdKGqiqqr009NV6mKTamHkehpv2ECEeHYqRYFaSjlBt5Gaoc0GYU1iLuHGhpQooMF93UAuSsZSwkkcx09pnWBwDtcyW2fKQEvgHa7gG3WCxWFqus7UVobcGypMZQ2MI+IiMOpUguFvpbXlLw3hAxQe0P1mb44B/YDd6JVan5XBHDbevt4CsRmg9VBgHJyE+C0QnKDb19XtWVTrPQ0XCr3trut9XZCBLdTz3eAMpn0BvP/wAg7r7EPiK61mAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/ic_edit_white.png
// module id = 219
// module chunks = 170